
/**
 * Data-driven UI application logic that pertains to user events and actions
 *
 * Created by ipatrikeeva on 06/06/2017
 */

/**
 * Handle and route view events
 * @param event {jQuery.Event} - view that triggered the event
 * @param action {string} - method parameters
 * @param hash {object} - event hash object
 */
function performAction(event, action, hash) {
    var method;
    // Parse the event to get the name of the method to call from view hash attribute
    if (action && hash) {
        method = hash[action];
        if (method && window[method]) {
            // Fire method by its global name
            window[method](event);
        }
    }
}